import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from '../06_incurr_trms/HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const TrmsAgeGender = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: 'ALL',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = { userAuth: localStorage.getItem("userAuth"), };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', 'ISS', '전체', '1세 미만', '1~9세', '10~19세', '20~29세', '30~39세', '40~49세', '50~59세', '60~69세', '70~79세', '80세 이상']; //component화 
    const dataColumn = ['TRMSEMNM', 'ISS_DIV', 'INDT_TOTAL', 'CNT0000', 'CNT0109', 'CNT1019', 'CNT2029', 'CNT3039', 'CNT4049', 'CNT5059', 'CNT6069', 'CNT7079', 'CNT8000'];
    const apiCall = '/trmsapi/patientstat/bdtongtrms_stat_patient_age_gender_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_외상환자 연령별 현황`;
    const excelHead = [];
    const mergeConfig = [{ key: 'TRMSEMNM', row: null }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['15%', '10%', '10%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    className='w-full'
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>성별</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="ALL">전체</option>
                                    <option value="M">남자</option>
                                    <option value="F">여자</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <p> * 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외 </p>
        </Main>
    )
}

export default TrmsAgeGender;